// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var footer = "Footer-module--footer--31LQy";
export var topSection = "Footer-module--topSection--3o1Yb";
export var section = "Footer-module--section--3U7Aq";
export var leftSideContent = "Footer-module--leftSideContent--1-o9f";
export var navigationLinksContainer = "Footer-module--navigationLinksContainer--ubRTt";
export var centerContent = "Footer-module--centerContent--1APf5";
export var rightSide = "Footer-module--rightSide--teRJo";
export var logosContainer = "Footer-module--logosContainer--1na0_";
export var logoFooter = "Footer-module--logoFooter--3aXv3";
export var logo = "Footer-module--logo--1Izfc";
export var title = "Footer-module--title--17eEI";
export var border = "Footer-module--border--3X-gx";
export var legalDocumentation = "Footer-module--legalDocumentation--VdtIy";
export var navigationLinks = "Footer-module--navigationLinks--i81E_";
export var link = "Footer-module--link--1KQCJ";
export var disabled = "Footer-module--disabled--3YdoI";
export var linkIcon = "Footer-module--linkIcon--FdR5t";
export var socialMediaSection = "Footer-module--socialMediaSection--3F8-G";
export var socialMedia = "Footer-module--socialMedia--1X4dP";
export var socialMediaLink = "Footer-module--socialMediaLink--uTqed Footer-module--link--1KQCJ";
export var divider = "Footer-module--divider--3IVhM";
export var copyright = "Footer-module--copyright--2Iyp5";
export var icon = "Footer-module--icon--2Zwla";
export var projectsAndIncentives = "Footer-module--projectsAndIncentives--31knh";
export var projectsAndIncentivesLeftBlock = "Footer-module--projectsAndIncentivesLeftBlock--YaFHX";
export var projectsAndIncentivesLogoContainer = "Footer-module--projectsAndIncentivesLogoContainer--atybK";
export var projectsAndIncentivesRightBlock = "Footer-module--projectsAndIncentivesRightBlock--1xXQv";
export var moscaSection = "Footer-module--moscaSection--2ANIm";
export var moscaSectionPt = "Footer-module--moscaSectionPt--10aae";
export var moscaLink = "Footer-module--moscaLink--2lTEh";